<template>
  <div id="picture">
    <!-- 轮播图信息 -->
    <diy-table
      :model="'picture'"
      :tableData="data.tableData"
      :tableMenu="data.tableMenu"
      :searchData="data.searchData"
      :searchButton="data.searchButton"
      :pageData="data.pageData"
      @showTableData="showTableData"
      @showSearchData="showSearchData"
      @showPageData="showPageData"
      @handleSearch="handleSearch"
      @handleClick="handleClick"
      @handleSelectionChange="handleSelectionChange"
    ></diy-table>
    <diy-drawer
      v-if="drawerData.flag"
      :drawerData="drawerData.data"
      :title="drawerData.title"
      :buttonList="drawerData.buttonList"
      @handleSuccessImg="handleSuccessImg"
      @handleErrorImg="handleErrorImg"
      @beforeUploadImg="beforeUploadImg"
      @deleteImg="deleteImg"
      @showDrawerData="showDrawerData"
      @colseDrawer="colseDrawer"
      @handleDrawerButton="handleDrawerButton"
    ></diy-drawer>
  </div>
</template>
<script>
import * as pictureData from "./picture.js";
import * as picture from "@/api/picture/picture.js";
export default {
  inject: ["reload"],
  data() {
    return {
      data: this.$base.initData("picture"),
      multipleSelection: [],

      drawerData: {
        flag: false,
        width: "20%",
        title: "",
        data: [],
        buttonList: [],
      },
      pictureItems: [
      { label: "首页轮播图", value: 0 },
      { label: "工具箱轮播图", value: 1 },
      ], //物品分类下拉框数据
      id: "",
    };
  },
  methods: {
    async initTableData() {
      let requestData = {
        pageSize: this.data.pageData.pageSize,
        pageNum: this.data.pageData.currentPage,
      };

      requestData = this.$total.array2json(this.data.searchData, requestData);
      let pictureListData = await picture.listPage(requestData);
      this.data.tableData = pictureListData.records;
      this.data.pageData.total = pictureListData.total;
    },
    /**
     * 顶部搜索按钮点击事件
     * @param {*} key
     */
    async handleSearch(key) {
      switch (key) {
        case "search":
          // 查询
          await this.initTableData();
          break;
        case "add":
          // 新增
          this.drawerData.title = "添加轮播图信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureAddpicture" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = pictureData.returnEditData();
          this.drawerData.flag = true;
          break;
        case "edit":
          // 编辑
          if (
            this.multipleSelection.length == 0 ||
            this.multipleSelection.length > 1
          ) {
            this.$message({
              message: "请选择一条数据进行编辑!",
              type: "error",
            });
            return;
          }
          this.drawerData.title = "编辑轮播图信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureUpdatepicture" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = pictureData.returnEditData();
          this.drawerData.data = this.$total.json2array(
            this.drawerData.data,
            this.multipleSelection[0]
          );
          this.drawerData.data.forEach((element) => {
            if (element.key == "picUrl") {
              element.imgList.push(element.value);
            }
          });
          console.log('this.multipleSelection[0] :>> ', this.multipleSelection[0], this.drawerData.data );

          // this.$total.fillArrayOptions(
          //   this.drawerData.data,
          //   "picType",
          //   this.pictureItems
          // );
          this.drawerData.flag = true;
          break;
        case "delete":
          // 删除
          if (this.multipleSelection.length == 0) {
            this.$message({
              message: "请至少选择一条数据进行删除操作!",
              type: "error",
            });
            return;
          }
          this.$confirm("此操作将永久删除所选的信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let ids = "";
              this.multipleSelection.forEach((item) => {
                ids = item.id + "," + ids;
              });
              let requestData = { ids: ids };
              await picture.deletepicture(requestData);
              await this.initTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });

          break;
        default:
          break;
      }
    },
    /**
     * 表格按钮点击事件
     * @param {*} val
     */
    handleClick(val) {
      let row = val.row;
      let key = val.key;
    },
    /**
     * 添加或修改新闻资讯
     * @param {*} flag
     */
    async saveOrUpdatepicture(flag) {},
    /**
     * 抽屉按钮点击事件
     * @param {*} key
     */
    async handleDrawerButton(key) {
      let requestData = {};
      let flag;
      switch (key) {
        case "cancel":
          this.colseDrawer();
          break;
        case "sureAddpicture":
          // 确认添加薪资
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );

          requestData.userId = requestData.displayName;

          await picture.addpicture(requestData);
          this.$message({
            message: "轮播图信息添加成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();
          break;
        case "sureUpdatepicture":
          // 确认修改薪资
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );

          requestData.userId = this.multipleSelection[0].userId;
          requestData.id = this.multipleSelection[0].id;
          await picture.updatepicture(requestData);
          this.$message({
            message: "轮播图信息修改成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();
          break;

        default:
          break;
      }
    },

    /**
     * 弹窗按钮点击事件
     * @param {*} key
     */
    async dialogOper(key) {
      let requestData = {};
      let flag;
      switch (key) {
        case "cancel":
          this.colseDialog();

          break;

        default:
          break;
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showTableData(val) {
      this.data.tableData = val;
    },
    showSearchData(val) {
      this.data.searchData = val;
    },
    showPageData(val) {
      this.data.pageData = val;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    showDialogData(val) {
      this.dialogData.data = val;
    },
    colseDrawer() {
      this.drawerData.flag = false;
    },
    showDrawerData(val) {
      this.drawerData.data = val;
    },
    handleSuccessImg(response, file, fileList) {
      if (response.code == "200") {
        switch (response.result.title) {
          case "物品封面":
            // 物品封面
            this.drawerData.data.forEach((element) => {
              if (element.key == "picUrl") {
                let url = response.result.url;
                element.imgList = [url];
                element.value = url;
              }
            });
            break;

          default:
            break;
        }
      }
      this.loading = false;
    },
    handleErrorImg() {
      this.$message({
        message: "文件上传失败!",
        type: "warning",
      });
      this.loading = false;
    },
    beforeUploadImg(file) {
      // console.log(file);
      // if (
      //   file.type == "image/jpeg" ||
      //   file.type == "image/jpg" ||
      //   file.type == "image/png"
      // ) {
      //   this.loading = true;
      // } else {
      //   this.$message({
      //     message: "仅支持上传JPG/JPEG/PNG格式!",
      //     type: "warning",
      //   });
      //   return false;
      // }
    },
    //删除照片
    deleteImg(item, index) {
      item.value.splice(index, 1);
    },
  },
  async mounted() {
    await this.initTableData();
  },
};
</script>
<style lang="less" scoped>
#picture {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
